import {
  CursorBasedWorkspaceMembers,
  SortEnum,
  UserWorkspaceStatusEnum,
  WorkspaceMembersV2Query,
  WorkspaceMembersV2QueryVariables,
} from '@/types/generated/graphql';
import { useCursorPagination, UseCursorPaginationReturn } from '@shared/hooks/use-cursor-pagination';
import { CURSOR_WORKSPACE_MEMBERS_V2 } from '@/graphql/cursor.graphql';

type UseWorkspaceMembersReturn = UseCursorPaginationReturn<CursorBasedWorkspaceMembers | null | undefined> & {
  getSelectOptions: () => {
    label: string;
    value: number | null | undefined;
  }[];
};

const useWorkspaceMembers = (props: { query?: string }): UseWorkspaceMembersReturn => {
  const cursorResult = useCursorPagination<WorkspaceMembersV2Query, WorkspaceMembersV2QueryVariables>({
    schema: CURSOR_WORKSPACE_MEMBERS_V2,
    variables: {
      status: UserWorkspaceStatusEnum.accepted,
      query: props.query,
      limit: 20,
      sort: SortEnum.ASC,
      order: 'user.name',
    },
    responseDataKey: 'workspaceMembersV2',
  });

  const getSelectOptions = () => {
    const items = cursorResult?.data?.data ?? [];
    return items.map((member) => ({
      label: member?.user?.name ?? '',
      value: member?.user?.id,
    }));
  };

  return {
    ...cursorResult,
    getSelectOptions,
  };
};

useWorkspaceMembers.getSelectOptions = () => {};
export default useWorkspaceMembers;
